import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import DatePreview from '@/components/DatePreview';
import classNames from 'classnames';
import styles from './index.less';
import { useResponsive } from '@/contexts/ResponsiveContext';
import { useTranslation } from 'react-i18next';

export const ModelExtraInfo = ({ label, value, type, customClassName, forceShow, bottomValue, format, truncate = true }) => {
  const { isMobile, isTablet } = useResponsive();
  const { t } = useTranslation('common');

  const component = useMemo(() => {
    switch (type) {
      case 'date':
        return <DatePreview value={value} prefix={label} format={format}/>;
      case 'datetime':
        return <DatePreview value={value} prefix={label} format={'LLLL'}/>;
      case 'boolean':
        return <div className={classNames({ 'flex': isMobile || isTablet }, { 'flex-col': bottomValue })}>
          {label && (isMobile || isTablet) && <div className="mr-1">{label}:</div>}
          <div>{value ? t('yes') : t('no')}</div>
        </div>;
      case 'number':
        return <div className={classNames({ 'flex': isMobile || isTablet }, { 'flex-col': bottomValue })}>
          {label && (isMobile || isTablet) && <div className="mr-1">{label}:</div>}
          <div className={truncate ? 'truncate' : ''}>{value || '0'}</div>
        </div>;
      default:
        return <div className={classNames({ 'flex': isMobile || isTablet }, { 'flex-col': bottomValue })}>
          {label && (isMobile || isTablet) && <div className="mr-1">{label}:</div>}
          <div className={truncate ? 'truncate' : ''}>{value || '-'}</div>
        </div>;
    }
  }, [type, value, label, format, isMobile, isTablet, bottomValue, t, truncate]);

  return (
    <span
      className={classNames({ 'lg:hidden': !forceShow }, styles.container, 'text-left text-black text-base w-full mb-1', customClassName)}>
      {component}
    </span>
  );
};

ModelExtraInfo.propTypes = {
  bottomValue: PropTypes.bool,
  forceShow: PropTypes.bool,
  type: PropTypes.string,
  format: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
  customClassName: PropTypes.any,
  truncate: PropTypes.bool
};

export default memo(ModelExtraInfo);
